// extracted by mini-css-extract-plugin
module.exports = {"container":"LeftNavbar-module--container--1NCNI"};